import EventUtils from "../../ts/utils/EventUtils";
import AnnotatedCodeListing from "./AnnotatedCodeListing";

export default class AnnotatedCodeListings {
    private annotatedCodeListings: Array<AnnotatedCodeListing>;

    constructor(rootElement: Element = null) {
        this.handleResize = this.handleResize.bind(this);
        this.annotatedCodeListings = [];
        
        const listingContainers = (rootElement || document).querySelectorAll(".listing-container, .browsable-container, .term-viewer-html-content");
        for(let i = 0; i < listingContainers.length; i++){
            const listingContainer = listingContainers[i];
            if(listingContainer.classList.contains("listing-container")
            || listingContainer.querySelector(".code-area-container") != null) {
                this.annotatedCodeListings.push(new AnnotatedCodeListing(listingContainer as HTMLElement));
            }
        }

        EventUtils.registerResizeStartCallback(this.handleResize);
    }

    public clean(){
        this.hideAll();
        
        if(this.annotatedCodeListings && this.annotatedCodeListings.length){
            this.annotatedCodeListings.forEach(it => it.clean());
        }
        
        this.annotatedCodeListings = [];

        EventUtils.unregisterResizeStartCallback(this.handleResize);
    }

    public hideAll(){
        this.hideAnnotations();
    }

    private hideAnnotations() {
        for(const annotedCodeListing of this.annotatedCodeListings){
            annotedCodeListing.hideAnnotations();
        }

        //$codeAnnotationContainer.css("opacity:0");
    }

    private handleResize(){
        this.hideAll();
    }
}